export interface NavigationItem {
	route: string;
	icon: string;
	adminOnly: boolean;
}
